export const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
        sx: {
            fontSize: { xs: "16px" },
            px: "8px",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            width: "auto",
            "&.Mui-selected": {
                borderTop: "1px solid #e6e6e6",
                borderLeft: "1px solid #e6e6e6",
                borderRight: "1px solid #e6e6e6",
            },
            "&:hover": {
                backgroundColor: "#e6e6e6",
            },
            mb: 1,
        },
    };
};
